import React from 'react';
import { useTranslation } from 'react-i18next';
import type { FlashStage } from '@/types/webflash';

const STAGES: FlashStage[] = ['erase', 'program', 'verify'];

const FlashProgressView: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('flash.title')}
      </h3>
      <div className="space-y-4">
        {STAGES.map((stage) => (
          <div key={stage}>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-gray-600 dark:text-gray-400">{t(`flash.stage.${stage}`)}</span>
              <span className="text-gray-400">0%</span>
            </div>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
              <div className="bg-gray-300 dark:bg-gray-600 h-2 rounded-full w-0 transition-all" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FlashProgressView;
